/**
 * -----------------------------------------------------------------------------------------------------------
 * Loading components
 * -----------------------------------------------------------------------------------------------------------
 */
import auth from 'src/router/auth'
import City from '../City'
import NewCity from '../NewCity'
import EditCity from '../EditCity'

/**
 * -----------------------------------------------------------------------------------------------------------
 * Define component
 * -----------------------------------------------------------------------------------------------------------
 */
export default [
  {
    path: '/cities',
    name: 'city',
    component: City,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/cities/create',
    name: 'create-city',
    component: NewCity,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/cities/edit/:id',
    name: 'edit-city',
    component: EditCity,
    beforeEnter: auth.requireAuth
  }
]



// WEBPACK FOOTER //
// ./src/components/city/routes/index.js